import {Component} from 'san';

import {getDateDiff} from '@/lib/utils/getDateDiff';
import styles from './style/index.module.less';


export default class RecentArticle extends Component {
    static template = require('./index.html');
    initData() {
        return {
            styles,
        };
    }
    attached() {
        const show_list = this.data.get('data');
        const nid = this.data.get('nid');
        this.storeDispatch('recentArticle:showLog', {nid, show_list});
    }
    clickHandler(event, newsData) {
        const nid = this.data.get('nid');
        this.storeDispatch('recentArticle:clkLog', {nid, click_nid: newsData.nid});
    }
    handleDateDiff(releaseTime) {
        return getDateDiff(releaseTime);
    }
}